import {
  colors,
  headingSizes,
  opacity,
  textSizes,
  weights,
} from '@components/theme/styles/index';
import { IconButton, Input, Stack, styled, Theme } from '@mui/material';
import { rem, rgba } from 'polished';
import { NavLink } from 'react-router-dom';

export const StyledHeader = styled('header')(
  ({ theme }: { theme: Theme }) =>
    ({
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      backgroundColor: 'white',
      marginTop: 'var(--sidebar-header-height)',
      height: 'var(--header-height)',
      display: 'flex',
      alignItems: 'center',
      borderBottom: `${rem(1)} solid ${colors.grayLight1}`,
      borderRight: `${rem(1)} solid ${colors.grayLight1}`,
      zIndex: 'var(--header-z)',
      [theme.breakpoints.up('sm')]: {
        position: 'sticky',
        gridRow: '1 / 1',
        gridColumn: '2 / -1',
        marginTop: 0,
        justifyContent: 'space-between',
        paddingTop: rem(10),
        paddingBottom: rem(10),
        paddingLeft: rem(50),
        paddingRight: rem(50),
      },
    }) as any,
);

export const HeaderTitle = styled('h3')({
  fontSize: headingSizes.h3,
  fontWeight: weights.semiBold,
  margin: 0,
  lineHeight: rem(20),
});

export const StyledIconButton = styled(IconButton)({
  color: colors.grayDark2,
  width: rem(40),
  height: rem(40),
});

export const StyledHeaderActions = styled(Stack)(
  ({ theme }: { theme: Theme }) =>
    ({
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'inline-flex',
        alignItems: 'center',
      },
    }) as any,
);

export const StyledSubMenuToggle = styled('button')(
  ({ theme }: { theme: Theme }) =>
    ({
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      width: rem(30),
      border: 'none',
      backgroundColor: colors.grayLight2,
      marginRight: rem(15),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    }) as any,
);

export const SubTitle = styled('span')(
  ({ theme }: { theme: Theme }) =>
    ({
      fontWeight: weights.normal,
      color: colors.grayDark1,
      fontSize: textSizes.base,
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'inline-block',
      },
    }) as any,
);

export const InviteNameBox = styled('span')<{ $disabled?: boolean }>(
  ({ $disabled = false }) => ({
    fontWeight: weights.normal,
    color: colors.grayDark1,
    fontSize: textSizes.base,
    display: 'inline-block',
    cursor: $disabled ? 'not-allowed' : 'pointer',
    pointerEvents: $disabled ? 'none' : 'auto',
    opacity: $disabled ? 0.5 : 1,
  }),
);

export const InviteName = styled('span')({
  display: 'inline-block',
  padding: `${rem(0)} ${rem(2)}`,
  cursor: 'pointer',
  transition: 'all 0.2s',
  fontSize: textSizes.xl,
  fontWeight: weights.medium,
  '&:hover': {
    color: colors.secondary,
  },
});

export const StyledAvatar = styled(IconButton)({
  border: `1px solid ${colors.gray}`,
  padding: 0,
  fontSize: rem(16),
  fontWeight: weights.semiBold,
  width: rem(40),
  height: rem(40),
});

export const StyledNavLink = styled(NavLink)({
  color: 'inherit',
  textDecoration: 'none',
});

export const StyledInput = styled(Input)({
  '&.MuiInputBase-root.Mui-focused': {
    // color: colors.secondary,
    backgroundColor: rgba(colors.blue, opacity._15),
    '&::after': {
      borderBottom: `2px solid ${colors.blue}`, // focused border color
    },
  },
});
